import { DashboardLinksModel, ProductUsageModel } from '@logz-pkg/models';
import { httpService } from '../../../core/http/request.provider';
import { ICrudApiService } from '../../utilities/types';
import { CrudApiService } from '../../utilities/crud.api.service';
import { usageMock } from './usage.mock';

export class UsageResponse {
  usage: ProductUsageModel[];
}

export interface IUsageCsvExport {
  filename: string;
  content: string;
}

class PlanUsageApiService implements ICrudApiService<UsageResponse> {
  dashboardApiService = new CrudApiService({ modelDefinition: DashboardLinksModel });

  urls = {
    quickSight: 'usage/quicksight-dashboard-link',
    exportCsv: '/usage/export/csv',
  };

  // The /v2/plan/usage endpoint has been decommissioned server-side (it returns 404). Ingested
  // plans therefore have no usage source and resolve to empty; non-ingested plans continue to
  // derive usage from the usage-buckets endpoint (via usageMock). See APPZ-3069.
  getUsage = async (isIngested: boolean): Promise<UsageResponse> => {
    if (isIngested) {
      return { usage: [] };
    }

    return usageMock.getUsage();
  };

  getQuicksightDashboardUrl = async (dashboardType?: keyof DashboardLinksModel): Promise<DashboardLinksModel> => {
    return this.dashboardApiService.get(this.urls.quickSight, { fresh: true }, { dashboardType });
  };

  exportUsageCsv = async (): Promise<IUsageCsvExport> => {
    const response = await httpService.get<string>(this.urls.exportCsv, undefined, undefined, undefined, {
      responseType: 'text',
    });

    const disposition = (response.headers?.['content-disposition'] as string) ?? '';
    const quotedMatch = disposition.match(/filename="([^"]+)"/i);
    const unquotedMatch = disposition.match(/filename=([^;]+)/i);
    const filename = quotedMatch?.[1] ?? unquotedMatch?.[1]?.trim() ?? 'usage.csv';

    return { filename, content: response.data };
  };
}

export const planUsageApiService = new PlanUsageApiService();
